export default {
  basepath: 'https://dev-ckysmall.ckc8.com/',
  buriedpointpath: 'https://testofflineckysdatacenter.ckc8.com/',
  downloadpath: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ckc.ckys.ckmanager',
  downloadshoppath: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ckc.ckys',
  datacenterpath: 'https://dev-ckysmall.ckc8.com/',
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
  cosuploadpath: 'https://dev-ckyscommon.ckc8.com/',
  cosaccesspath: 'https://testckysrestatic.ckc8.com/Uploads/',
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
  staticImgUrl: 'https://ckysrestatic.ckc8.com/', // 图片地址
  ossImgUrl: 'https://devstaticfile.oss-cn-shanghai.aliyuncs.com/' // 图片地址
}



// WEBPACK FOOTER //
// ./src/assets/config/path_dev.js